export function mergeOpening<T extends object, U extends object>(
  previous: T | null,
  incoming: U
): T & U {
  return (previous ? { ...previous, ...incoming } : incoming) as T & U;
}
